import mutations from './mutations'
import actions from './actions'

const state = {
  all_users: [],
  users: [],
  user: [],
  deleted_users: [],
  all_public_users: [],
  wallet_balance_kes: 0,
  wallet_balance_usd: 0,
  wallet_transactions: [],
  wallet_transactions_total: 0,
  current_transaction: null,
  booking_transactions: [],
  user_deposits: [],

}

export default {
  state, mutations, actions
}
